const CategoryTreeNode = require('./categoryTreeNode');
const cateApi = require('../../api/category');
const EventEmitter = require('events').EventEmitter;
const caseApi = require('../../api/CaseManage');
class CategoryTree extends EventEmitter {

    MAX_DEEP = 3;

    MAX_SELECTED = 10;

    getTitle(node, title) {
        const _this = this;
        if (node && node.cateParent && node.cateParent > 0) {
            return _this.getTitle(window.cateTree.categoryMap[node.cateParent]) + "-" + node.cateTitle;
        } else {
            return node.cateTitle
        }
    }

    screenCate(data) {
        let sc = [];
        data.forEach(dt => {
            let canAdd = true;
            if (dt.cateLevel == 1) {
                for (let ch of dt.originalChildren) {
                    if (!ch.checked) {
                        canAdd = false;
                        break;
                    }
                }
                canAdd && sc.push(dt)
            } else if (dt.cateLevel == 2 && !sc.includes(this.categoryMap[dt.cateParent])) {
                for (let ch of dt.originalChildren) {
                    if (!ch.checked) {
                        canAdd = false;
                        break;
                    }
                }
                canAdd && sc.push(dt);
            } else if (dt.cateLevel == 3 && !sc.includes(this.categoryMap[dt.cateParent]) && !sc.includes(this.categoryMap[dt.cateRoot])) {
                sc.push(dt);
            }
        });
        return sc;
    }

    constructor() {
        super();
        this.firstData = [];
        this.secondData = [];
        this.thirdData = [];
        this.categoryMap = {};
    }

    get selectedCategories() {
        return this._selectedCategories;
    }

    set selectedCategories(value) {
        this._selectedCategories = value;
    }

    get dataInBase() {
        return this._dataInBase;
    }

    set dataInBase(value) {
        this._dataInBase = value;
    }

    get firstData() {
        return this._firstData;
    }

    set firstData(value) {
        this._firstData = value;
    }

    get secondData() {
        return this._secondData;
    }

    set secondData(value) {
        this._secondData = value;
    }

    get thirdData() {
        return this._thirdData;
    }

    set thirdData(value) {
        this._thirdData = value;
    }

    updateTreeData() {
        let _this = this;
        this.tree.children = [];
        cateApi.getAllCategory((res) => {
            _this.getTreeData(res);
        });
    }

    getTreeData(res) {
        this.dataInBase = res.data.data;
        this.firstData = [];
        this.secondData = [];
        this.thirdData = [];
        this.categoryMap={};
        this.dataInBase.forEach(d => {
            let doing = true;
            let ct = new CategoryTreeNode(d);
            if (ct.cateLevel == 1 && (this.firstData.length <= 0 || this.firstData.indexOf(ct) < 0)) {
                if (this.firstData.length > 0) {
                    for (let index in this.firstData) {
                        if (this.firstData[index].cateId == ct.cateId) {
                            doing = false;
                            break;
                        }
                    }
                }
                if (doing) {
                    this.firstData.push(ct);
                }
            }
            if (ct.cateLevel == 2 && (this.secondData.length <= 0 || this.secondData.indexOf(ct) < 0)) {
                if (this.secondData.length > 0) {
                    for (let index in this.secondData) {
                        if (this.secondData[index].cateId == ct.cateId) {
                            doing = false;
                            break;
                        }
                    }
                }
                if (doing) {
                    this.secondData.push(ct);
                }
            }
            if (ct.cateLevel == 3 && (this.thirdData.length <= 0 || this.thirdData.indexOf(ct) < 0)) {
                if (this.thirdData.length > 0) {
                    for (let index in this.thirdData) {
                        if (this.thirdData[index].cateId == ct.cateId) {
                            doing = false;
                            break;
                        }
                    }
                }
                if (doing) {
                    this.thirdData.push(ct);
                }
            }
            this.categoryMap[ct.cateId] = ct;
        });

        this.emit('update', this.getTree());
    }

    get tree() {
        if (!this._tree) {
            this._tree = [];
        }
        return this._tree;
    }

    set tree(value) {
        this._tree = value;
    }

    getTree() {
        let tree = {};
        tree['cateTitle'] = "";
        tree['disabled'] = true;
        tree['expand'] = true;
        if (this.secondData.length > 0) {
            this.secondData.forEach(sd => {
                if (this.selectedCategories && this.selectedCategories.length > 0 && this.selectedCategories.includes(sd.cateId))
                    sd.checked = true;
                else sd.checked = false;
                this.firstData.forEach(fd => {
                    if (this.selectedCategories && this.selectedCategories.length > 0 && this.selectedCategories.includes(fd.cateId))
                        fd.checked = true;
                    else fd.checked = false;
                    if (fd.cateId == sd.cateParent && (fd.originalChildren.length <= 0 || !fd.originalChildren.includes(sd))) {
                        fd.originalChildren.push(sd);
                    }
                    if (fd.cateId == sd.cateParent && (fd.children.length <= 0 || !fd.children.includes(sd))) {
                        fd.children.push(sd);
                    }
                });
                this.thirdData.forEach(td => {
                    if (this.selectedCategories && this.selectedCategories.length > 0 && this.selectedCategories.includes(td.cateId))
                        td.checked = true;
                    else td.checked = false;
                    if (td.cateParent == sd.cateId && !sd.originalChildren.includes(td)) {
                        sd.originalChildren.push(td);
                    }
                    if (td.cateParent == sd.cateId && !sd.children.includes(td)) {
                        sd.children.push(td);
                    }
                })
            });
        }
        tree['children'] = this.firstData;
        tree['originalChildren'] = this.firstData;
        this._tree = [tree];
        return this._tree;
    }

    setupData(parent, isParentVisible) {
        if (parent && Array.isArray(parent.originalChildren) && parent.originalChildren.length) {
            let _this = this;
            parent.children = [];
            parent.isVisible = isParentVisible;
            parent.originalChildren.forEach(childNode => {
                if (this.selectedCategories && this.selectedCategories.length > 0 && this.selectedCategories.includes(childNode.cateId))
                    childNode.checked = true;
                else childNode.checked = false;
                childNode.expand = false;
                childNode.isVisible = true;
                parent.children.push(childNode);
                _this.setupParent(parent);
                _this.setupData(childNode, true);
            });
        }
    }

    setupParent(node) {
        if (node.cateParent >= 0) {
            let parent = node.cateParent === 0 ? this._tree[0] : this.categoryMap[node.cateParent];
            if (parent && !parent.children.includes(node)) {
                parent.children.push(node);
                this.setupParent(parent);
            }
        }
    }

    setTreeSelected(node) {
        const _this = this;
        if (node) {
            if (this.selectedCategories && this.selectedCategories.includes(node.cateId)) {
                if (node.cateLevel == 3) {
                    node.checked = true;
                } else {
                    node.singleCheck = true;
                    node.checked = false;
                }
            } else {
                node.checked = false;
                node.indeterminate = false;
                node.singleCheck = false;
            }
            if (node.children && !node.checked) {
                node.children.forEach(dt => {
                    _this.setTreeSelected(dt);
                })
            }
        }
    }

    setMultiOrSingle(node, singleCheck) {
        const _this = this;
        if (node && node.children) {
            node.children.forEach(dt => {
                if (dt.singleCheck) {
                    let iii = _this.isChecked(dt);
                    if (!iii) {
                        dt.singleCheck = false;
                        dt.checked = true;
                    } else {
                        if (!singleCheck.includes(dt)) {
                            singleCheck.push(dt);
                        }
                    }
                }
                _this.setMultiOrSingle(dt, singleCheck)
            });
        }
    }


    //查询孩子或者子孩子或者子子孩子是否被选中
    isChecked(node) {
        const _this = this;
        if (node && node.children) {
            let canGo = node.children.some(item => {
                if (item.checked || item.singleCheck) return true;
            })
            if (canGo) {
                return true;
            } else {
                for (let dt of node.children) {
                    return _this.isChecked(dt);
                }
            }
        }
        return false;
    }

    searchCate(name) {
        let _this = this;
        if (name) {
            _this._tree[0].children = [];
            let parent = _this._tree[0].children;
            let keys = Object.keys(this.categoryMap);
            keys.forEach(key => {
                if (_this.categoryMap[key].cateTitle.toLowerCase().includes(name.toLowerCase())) {
                    let item = new CategoryTreeNode(_this.categoryMap[key]);
                    item.cateTitle = _this.setItemName(item);
                    if (this.selectedCategories && this.selectedCategories.length > 0 && this.selectedCategories.includes(item.cateId))
                        item.checked = true;
                    else item.checked = false;
                    parent.push(item);
                }
            })
        }
        else {
            _this.setupData(this._tree[0], true);
        }
        if (this._tree[0])
            this._tree[0].expand = true;
        return;
    }

    setItemName(item) {
        const _this = this;
        if (item.cateParent && this.categoryMap[item.cateParent] && this.categoryMap[item.cateParent].cateLevel) {
            let parentName = _this.setItemName(_this.categoryMap[item.cateParent]);
            if (item.cateTitle.indexOf(parentName) >= 0) {
                return item.cateTitle;
            } else {
                return parentName + "-" + item.cateTitle;
            }
        } else if (item.cateLevel === 1) {
            return item.cateTitle;
        }
    }

    getCateParents(item) {
        this.cateParents = [];
        let level = 2;
        for (let key in this.categoryMap) {
            if (this.categoryMap[key].cateParent == item.cateId) {
                level = item.cateLevel - 1;
                break;
            }
        }
        this.getCateP(this.tree[0].originalChildren,level,this.cateParents,item.cateTitle);

        // for (let key in this.categoryMap) {
        //     if (this.categoryMap[key].cateLevel <= level && this.categoryMap[key].cateTitle != item.cateTitle) {
        //         let item = new CategoryTreeNode(this.categoryMap[key]);
        //         let ct = this.setItemName(item);
        //         if(ct){
        //             item.cateTitle = ct.trim();
        //             this.cateParents.push(item);
        //         }
        //     }
        // }
        return this.cateParents;
    }

    getCateP(cateArr,level,parents,cateTitle){
        const _this = this;
        if(cateArr && cateArr.length){
            for(let ca of cateArr){
                if(ca.cateLevel <= level && ca.cateTitle != cateTitle){
                    let item = new CategoryTreeNode(ca);
                    let ct = this.setItemName(item);
                    if(ct){
                        item.cateTitle = ct.trim();
                        parents.push(item);
                    }
                }
                _this.getCateP(ca.originalChildren,level,parents,cateTitle);
            }
        }
    }

    getTreeNode(node, first) {
        const _this = this;
        if (first) {
            _this.treeItems = {};
        }
        if (node.children && node.children.length) {
            node.children.forEach(item => {
                _this.treeItems[item.cateId] = (item);
                _this.getTreeNode(item, false);
            })
        }
    }

    updateTreeNodeInfo(array,node){
        const _this = this;
        if(array && array.children && array.children.length){
            for(let a of array.children){
                if(a.cateId == node.cateId){
                    console.log(node);
                    a.cateRoot = node.cateRoot;
                    a.cateLabel = node.cateLabel;
                    a.cateParent = node.cateParent;
                    a.cateTitle = node.cateTitle;
                    a.cateIndex = node.cateIndex;
                    a.cateIcon = node.cateIcon;
                    return;
                }
                _this.updateTreeNodeInfo(a,node);
            }
        }

    }

    get treeItems() {
        return this._treeItems;
    }

    set treeItems(value) {
        this._treeItems = value;
    }

    get cateParents() {
        return this._cateParents;
    }

    set cateParents(value) {
        this._cateParents = value;
    }

    get medias() {
        return this._medias;
    }

    set medias(value) {
        this._medias = value;
    }


    get userRoles() {
        return this._userRoles;
    }

    set userRoles(value) {
        this._userRoles = value;
    }

    getMedias() {
        caseApi.getMedias((res) => {
            this.medias = res.data.data;
        })
    }

    getUserRole() {
        caseApi.getUserRole(res => {
            this.userRoles = res.data.data;
            this.emit('getRole', this.userRoles);
        });
    }

    get languages() {
        return this._languages;
    }

    set languages(value) {
        this._languages = value;
    }

    getLanguage() {
        caseApi.getLanguage(res => {
            this.languages = res.data.data;
        })
    }
}

module.exports = CategoryTree;


// WEBPACK FOOTER //
// ./src/bo/categoryManage/categoryTree.js